import { BaseListView } from "@/base/BaseListView";
import { definePendingListView } from "@/base/list/defineListView";

// Quotes (BRK-S251): a BaseListView page PMS can't serve yet. Quotes are read
// per submission today (`GET /api/broker/submissions/{id}/quotes`), so the
// panel sends the broker there. BRK-S210 wires this list to the brokerage-wide
// `GET /api/broker/quotes` once PMS-S561 ships it; the columns are its.
const QUOTES_LIST = definePendingListView({
  plannedEndpoint: "/api/broker/quotes",
  noun: "quotes",
  title: "Quotes",
  context: "Offers from our markets on your submissions.",
  columns: [
    "Quote",
    "Coverage",
    "Carrier",
    "Valid until",
    "Total cost",
    "Stage",
  ],
  notYetAvailable: {
    title: "Quotes live on each submission",
    body: "Open a submission to compare its quotes.",
    href: "/submissions",
    linkLabel: "Go to Submissions",
  },
});

export function QuotesPage() {
  return <BaseListView def={QUOTES_LIST} />;
}
